module.exports = __webpack_public_path__ + "img/warning.67b4ce12.png";